module.exports = __webpack_public_path__ + "static/media/venvi.04cdf321.png";